import chatBotSwitzerlandDe from './chatbot-ch-de.js';
import chatBotSwitzerlandFr from './chatbot-ch-fr.js';
import chatBotFrance from './chatbot-fr-fr.js';
import chatBotAustralia from './chatbot-au.js';
import chatBotUsa from './chatbot-us-production.js';
import { SiteDomain } from '../../types/app-state.js';
// import { Network } from '../network-globals.js';
// import { DEPLOYMENT_ENVIRONMENT } from '../../config.js';

export const getChatbotLoader = (target: string, siteId: string, siteSettings: SiteDomain[], deploymentEnvironment: string) => {
    const sitesWithChatbots = siteSettings.reduce((acc, network) => {
        switch (network.siteLanguage) {
            case 'de-ch':
                acc.switzerlandSiteGerman = network;
                break;
            case 'fr-ch':
                acc.switzerlandSiteFrench = network;
                break;
            case 'fr':
                acc.frenchSite = network;
                break;
            case 'en-us':
                acc.usSite = network;
                break;
            case 'en-au':
                acc.australianSite = network;
                break;
        }
        return acc;
    }, {} as any);


    if (target === 'live') {
        return getLiveChatbot(sitesWithChatbots, siteId, deploymentEnvironment);
    }

    return null;

    // return getDraftChatbot(sitesWithChatbots, res);
};

const getLiveChatbot = (sitesWithChatbots: any, siteId: string, deploymentEnvironment: string) => { // eslint-disable-line @typescript-eslint/no-unused-vars
    const {
        usSite,
        switzerlandSiteGerman,
        switzerlandSiteFrench,
        frenchSite,
        australianSite,
    } = sitesWithChatbots;

    let chatBotScriptLoader = null;

    switch (siteId) {
        case usSite?.siteId:
            chatBotScriptLoader = chatBotUsa;
            break;
        case switzerlandSiteGerman?.siteId:
            // Switzerland (german-language chatbot)
            chatBotScriptLoader = chatBotSwitzerlandDe;
            break;
        case switzerlandSiteFrench?.siteId:
            // Switzerland (french-language chatbot)
            chatBotScriptLoader = chatBotSwitzerlandFr;
            break;
        case frenchSite?.siteId:
            chatBotScriptLoader = chatBotFrance;
            break;
        case australianSite?.siteId:
            chatBotScriptLoader = chatBotAustralia;
            break;
    }

    if (!chatBotScriptLoader) {
        return null;
    }

    // res.set('Referrer-Policy', 'strict-origin-when-cross-origin');

    return chatBotScriptLoader;
};

// const getDraftChatbot = (sitesWithChatbots: any, res: any) => {
//     // Chatbots under development
//     const {
//         australianSite,
//     } = sitesWithChatbots;
    
//     let chatBotScriptLoader = '';

//     switch (res.locals.siteId) {
//         case australianSite?.siteId:
//             chatBotScriptLoader = chatBotAustralia;
//             break;
//     }

//     if (!chatBotScriptLoader) {
//         return;
//     }

//     res.set('Referrer-Policy', 'strict-origin-when-cross-origin');

//     return chatBotScriptLoader;
// };
